import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/faq",
        method: "get",
        params: data
    });
}

export function handleCreateStoreApi(data) {
    if (data.id) {
        return request({
            url: "/admin/faq/" + data.id,
            method: "put",
            data
        });
    } else {
        return request({
            url: "/admin/faq",
            method: "post",
            data
        });
    }
}

export function handleDeleteApi(data) {
    return request({
        url: "/admin/faq/" + data.id,
        method: "delete"
    });
}


export function handleLogDataApi(data) {
    return request({
        url: "/admin/faq_log",
        method: "get",
        params: data
    });
}

export function handleGetSelectApi() {
    return request({
        url: "/admin/get_faq_select",
        method: "get",
    });
}


export function handleCenterListApi(data) {
    return request({
        url: "/admin/faq_center",
        method: "get",
        params: data
    });
}


// 获取单个 faq的信息
export function getSingleFaqApi(data) {
    return request({
        url: "/admin/faq/" + data.id,
        method: "get",
        params: data
    });
}
